import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
const LoadingBackdrop = ({ open, message = 'Loading...' }) => {
    return (_jsx(Backdrop, { open: open, sx: { color: '#fff', zIndex: (theme) => theme.zIndex.modal + 200 }, children: _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center' }, children: [_jsx(CircularProgress, { color: "inherit" }), _jsx(Typography, { variant: "subtitle1", sx: { mt: 2 }, children: message })] }) }));
};
export default LoadingBackdrop;
